module.exports = __webpack_public_path__ + "static/img/Peopleplus_Logo-01.179578e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/votefriend/images/Peopleplus_Logo-01.png
// module id = 2972
// module chunks = 1